import { getNodeList } from '@/apis';
import list from 'antd/es/list';

export default {
    name: 'nodeConfig',
    initialState: {
        list: [],
    },
    reducers: {
        setNodeList: (state, { payload }) => {
            state.list = payload;
        },
    },
    effects: (dispatch: any) => {
        return {
            async getNodeList(state, { payload: param = {} } = {}) {
                const { data: list = [] } = await getNodeList({
                    page: 0,
                    page_num: 50000,
                    ...param,
                });
                // 注入redux
                dispatch.nodeConfig.setNodeList(list);
                return list;
            },
        };
    },
};
